/** The YouTube id shape accepted by the playlist service and player. */
export const YOUTUBE_VIDEO_ID = /^[A-Za-z0-9_-]{11}$/
